var _effectorFileName = "/builds/gmini/front-ui-kit/src/Page404/Page404.tsx";
import { ErrorPageTemplate } from '../ErrorPageTemplate/ErrorPageTemplate';
import { Page404HugeText, Page404Link, Page404HugeTextWrapper, OrangeDotSVG, PathPositioned, FlyPositioned } from './Page404.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const Page404 = () => /*#__PURE__*/_jsx(ErrorPageTemplate, {
  composition: /*#__PURE__*/_jsxs(Page404HugeTextWrapper, {
    children: [/*#__PURE__*/_jsx(Page404HugeText, {
      children: "\u041E\u0439!"
    }), /*#__PURE__*/_jsx(OrangeDotSVG, {
      viewBox: "0 0 20 20",
      width: "20px",
      height: "20px",
      children: /*#__PURE__*/_jsx("circle", {
        cx: "10px",
        cy: "10px",
        r: "10px",
        fill: '#FF5C2C'
      })
    }), /*#__PURE__*/_jsx(PathPositioned, {}), /*#__PURE__*/_jsx(FlyPositioned, {})]
  }),
  mediumText: /*#__PURE__*/_jsx(_Fragment, {
    children: "\u041A\u0430\u0436\u0435\u0442\u0441\u044F \u0447\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A! \u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043A\u043E\u0442\u043E\u0440\u0443\u044E \u0432\u044B \u0437\u0430\u043F\u0440\u0430\u0448\u0438\u0432\u0430\u0435\u0442\u0435, \u043D\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442. \u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043E\u043D\u0430 \u0431\u044B\u043B\u0430 \u0443\u0434\u0430\u043B\u0435\u043D\u0430, \u0438\u043B\u0438 \u0432\u044B \u043D\u0430\u0431\u0440\u0430\u043B\u0438 \u043D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0430\u0434\u0440\u0435\u0441."
  }),
  smallText: /*#__PURE__*/_jsxs(_Fragment, {
    children: ["\u041F\u0435\u0440\u0435\u0439\u0434\u0438\u0442\u0435 \u043D\u0430 ", /*#__PURE__*/_jsx(Page404Link, {
      href: '/',
      children: "\u0441\u0442\u0430\u0440\u0442\u043E\u0432\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443"
    }), ' ', "\u043C\u043E\u0434\u0443\u043B\u044F \u0438 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043D\u0430\u0439\u0442\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0443\u044E \u0432\u0430\u043C \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u0442\u0430\u043C."]
  }),
  errorCode: '404'
});